import dayjs from "dayjs"
import BaseTableRow from "../../../../components/layout/BaseTableRow"
import { Link, useNavigate } from "react-router-dom"
import { Navigation } from "../../../../api/constants"

type BillCreditTableRowType = {
    createdAt: Date | string
    paymentRequirement: {
        expected_payment: number
        invoice_date: Date
        due_date: Date
    }
    customer: {
        _id: string
        customer: {
            name: string
            softDeleteAfter?: Date
        }
    }
    bill: {
        _id: string
        nr: string
    }
    amount: number
    comment?: string
    onClick: () => void
}

export default function BillCreditTableRow(props: BillCreditTableRowType) {
    const navigate = useNavigate()
    return (
        <BaseTableRow classProps={``} onClick={props.onClick}>
            <td className="hidden md:table-cell">
                <p className="line-clamp-1 text-center">{dayjs(props.createdAt).format("DD.MM.YYYY")}</p>
            </td>
            <td>
                <p> {props.customer?.customer?.name}</p>
            </td>
            <td>
                <button onClick={() => navigate(Navigation.BILL_DETAILED + props.bill?._id)} className="line-clamp-1 text-center underline">
                    {props.bill?.nr}
                </button>
            </td>
            <td>
                <p className="line-clamp-1  text-center">
                    {props.paymentRequirement.expected_payment?.toFixed(2)?.toString()?.replace(".", ",")} € (fällig am {dayjs(props.paymentRequirement.due_date).format("DD.MM.YYYY")})
                </p>
            </td>
            <td>
                <p className="line-clamp-1  text-center">{props.amount?.toFixed(2)?.toString()?.replace(".", ",")} €</p>
            </td>
            <td className="table-cell">
                <p title={props.comment} className="line-clamp-1 text-center">
                    {props.comment}
                </p>
            </td>
        </BaseTableRow>
    )
}
